module.exports = __webpack_public_path__ + "static/media/4QPF.5b2ed002.png";